/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Directive, ElementRef, AfterViewInit, Input, AfterViewChecked } from '@angular/core';
import { XdaStringsService } from '../services/xda-strings.service';

@Directive({
  selector: '[xdaTranslate]',
  standalone: false,
})
export class XdaTranslateDirective implements AfterViewInit, AfterViewChecked {
  @Input('xdaTranslate') translateText: string;
  @Input() formatValues: string | string[];

  constructor(
    private element: ElementRef,
    private xdaStringsService: XdaStringsService,
  ) {}

  //After View is loaded translate element
  ngAfterViewInit() {
    this.translateElement();
  }

  //After content changes translate element
  ngAfterViewChecked() {
    this.translateElement();
  }

  // Take translated string and replace html text with it (if it is different)
  translateElement() {
    const translatedText = this.getTranslatedText();

    // Verify value came back, and its different than what is displayed currently
    if (
      translatedText != null &&
      translatedText != '' &&
      translatedText != this.element.nativeElement.innerHTML &&
      translatedText != this.element.nativeElement.innerText
    ) {
      this.element.nativeElement.innerHTML = translatedText;
    }
  }

  // Grab SDE string and pull translated value from strings service
  getTranslatedText(): string {
    const sdeString =
      this.translateText || this.element.nativeElement.innerText;
    let translatedString = this.xdaStringsService.strings[sdeString];
    if (translatedString) {
      // If we are formatting values, format the translatedString
      if (this.formatValues) {
        if (!Array.isArray(this.formatValues)) {
          this.formatValues = [this.formatValues];
        }
        const matches = translatedString.match(/\{(\d)\}/g);
        if (matches && matches.length !== this.formatValues.length) return '';
        if (matches) {
          matches.forEach((match, idx) => {
            let value = this.formatValues[idx].toString().trim();
            value = this.xdaStringsService.strings[value] || value;
            translatedString = translatedString.replace(match, value);
          });
        }
      }
      return translatedString;
    }
    return this.translateText;
  }
}
